export enum DriversType {
  Contracted = 'CONTRACTED',
  Freelance = 'FREELANCE',
  Fleet = 'FLEET'
}
